import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../../i18n'
import { useAuth } from './AuthenticationProvider'
import { useParams, Link } from 'react-router-dom'
import { GetConfiguration } from '../Configuration/ConfigurationManager'
import { GetADToken } from '../Utilities/TokenManager'
import { IsSafeUrl, RedirectWarning  } from '../Utilities/SafeUrl'
import { ErrorBox } from '../Utilities/ErrorBox'
import { GenericErrorBox } from '../UI/ErrorBox/GenericErrorBox'; 
import usePageTitle from '../../Hooks/usePageTitle';
import { GetCookieValue, DeleteCookie } from '../Utilities/ADFECookie'
export function Logout(props) {
    const auth = useAuth();
    const [errors, setErrors] = useState([]);
    const [isNotTrusted, setIsNotTrusted] = useState('');
    const { environment } = useParams();
    const [currentOperation, setCurrentOperation] = useState([]);
    const [hasLoggedOut, setHasLoggedOut] = useState(false);

    var params = (new URL(document.location)).searchParams;
    var returnUrl = params.get("ReturnUrl");
    var isCallback = params.get("IsCallback");
    var isAuthLogout = params.get("IsAuthLogout");
    var logoutCookie = GetCookieValue("logoutRedirection");
    if (!returnUrl && logoutCookie) {
        if (logoutCookie) {
            returnUrl = decodeURIComponent(logoutCookie.split("&")[0].split("=")[1]);
            isCallback = logoutCookie.split("&")[1].split("=")[1];
            isAuthLogout = logoutCookie.split("&")[2].split("=")[1];
        }
    }
    var refToken = params.get("refToken");
    if (!returnUrl) {
        returnUrl = window.location.origin;
    }
    usePageTitle(`Logout processing - ${props.brandingElement?.id}`);

    // 🔹 1. LOGOUT SIDE EFFECT (runs once)
    useEffect(() => {
        if (!isCallback && !hasLoggedOut) {
            setHasLoggedOut(true);
            auth.Logout(returnUrl, refToken);
        }
    }, [isCallback, hasLoggedOut, auth, returnUrl, refToken]);

    // 🔹 2. CLEAR USER DATA ON CALLBACK
    useEffect(() => {
        if (isCallback && auth.userData) {
            auth.ClearUserData();
        }
    }, [isCallback, auth]);

    const redirectToLoginUrl = window.location.href.replace("logout", "login");

    // 🔹 3. REDIRECT TO LOGIN (AFTER LOGOUT COMPLETES)
    useEffect(() => {
        if (isCallback && !auth.userData) {
            IsSafeUrl(returnUrl, environment).then((result) => {
                if (result) {
                    if (isAuthLogout) 
                        window.location.href = returnUrl;
                    else
                        window.location.href = redirectToLoginUrl;
                }
                else {
                    window.location.href= redirectToLoginUrl
                    if (!isNotTrusted) {
                        setIsNotTrusted(redirectToLoginUrl);
                    }
                }
                })
                .catch(err => setErrors([err]));
        }
    }, [isCallback, auth.userData, returnUrl, environment, redirectToLoginUrl, isNotTrusted, isAuthLogout]);


    return (<div className="center-column">
        <GenericErrorBox errors={errors} />
        <RedirectWarning isNotTrusted={isNotTrusted} returnUrl={returnUrl} />
    </div>);
}